import Vue from "vue"
import moment from "moment"
import axios from "axios"
import Notify from "vue2-notify"
import UiKit from "@hudlab/ui-kit"
import ResourceSelect from "@/components/ResourceSelect"

import { library } from "@fortawesome/fontawesome-svg-core"

import {
  faFileContract as falFileContract,
  faTimes as falTimes,
  faFile as falFile,
  faFolder as falFolder,
  faArchive as falArchive,
  faHomeLgAlt as falHomeLgAlt,
  faChartBar as falChartBar,
  faPresentation as falPresentation,
  faMobileAlt as falMobileAlt,
  faDesktop as falDesktop,
  faEnvelopeOpenText as falEnvelopeOpenText,
  faPaperPlane as falPaperPlane,
  faComments as falComments,
  faEuroSign as falEuroSign,
  faPencil as falPencil,
  faLock as falLock,
  faLightbulb as falLightbulb,
  faPaperclip as falPaperclip,
  faSearch as falSearch,
  faGlobeEurope as falGlobeEurope,
  faTools as falTools,
  faUsers as falUsers,
  faCalendarAlt as falCalendarAlt,
  faDownload as falDownload,
  faRocket as falRocket,
  faStar as falStar,
  faFolderOpen as falFolderOpen,
  faFileExclamation as falFileExclamation,
  faMoneyBillAlt as falMoneyBillAlt,
  faUserGraduate as falUserGraduate,
  faUserHardHat as falUserHardHat,
  faBooks as falBooks,
  faCalendarPlus as falCalendarPlus,
  faShapes as falShapes,
  faCommentsDollar as falCommentsDollar,
  faUniversity as falUniversity,
  faStore as falStore,
  faHandHoldingUsd as falHandHoldingUsd,
  faIdCard as falIdCard,
  faCars as falCars,
  faRingsWedding as falRingsWedding,
  faCogs as falCogs,
  faUserTie as falUserTie,
  faBuilding as falBuilding,
  faScrewdriver as falScrewdriver,
  faFileSearch as falFileSearch,
  faExclamationTriangle as falExclamationTriangle,
  faCheckSquare as falCheckSquare,
  faTable as falTable,
  faRoad as falRoad,
  faGasPump as falGasPump,
  faUmbrellaBeach as falUmbrellaBeach
} from "@fortawesome/pro-light-svg-icons"
import {
  faGhost as fadGhost,
  faEdit as fadEdit,
  faFile as fadFile,
  faFileUpload as fadFileUpload,
  faFolderOpen as fadFolderOpen,
  faFolder as fadFolder,
  faArchive as fadArchive,
  faHomeLgAlt as fadHomeLgAlt,
  faTools as fadTools,
  faChartBar as fadChartBar,
  faPresentation as fadPresentation,
  faCalendarAlt as fadCalendarAlt,
  faUsers as fadUsers,
  faMobileAlt as fadMobileAlt,
  faDesktop as fadDesktop,
  faDownload as fadDownload,
  faRocket as fadRocket,
  faEnvelopeOpenText as fadEnvelopeOpenText,
  faPaperPlane as fadPaperPlane,
  faComments as fadComments,
  faEuroSign as fadEuroSign,
  faPencil as fadPencil,
  faLock as fadLock,
  faLightbulb as fadLightbulb,
  faPaperclip as fadPaperclip,
  faSearch as fadSearch,
  faStar as fadStar,
  faGlobeEurope as fadGlobeEurope,
  faFileDownload as fadFileDownload,
  faSignature as fadSignature,
  faCloudUploadAlt as fadCloudUploadAlt,
  faFileSignature as fadFileSignature,
  faCog as fadCog,
  faMoneyBillAlt as fadMoneyBillAlt,
  faUserGraduate as fadUserGraduate,
  faUserHardHat as fadUserHardHat,
  faBooks as fadBooks,
  faCalendarPlus as fadCalendarPlus,
  faShapes as fadShapes,
  faCommentsDollar as fadCommentsDollar,
  faUniversity as fadUniversity,
  faStore as fadStore,
  faHandHoldingUsd as fadHandHoldingUsd,
  faIdCard as fadIdCard,
  faCars as fadCars,
  faRingsWedding as fadRingsWedding,
  faCogs as fadCogs,
  faUserTie as fadUserTie,
  faBuilding as fadBuilding,
  faAbacus as fadAbacus,
  faFileMedical as fadFileMedical,
  faFileMedicalAlt as fadFileMedicalAlt,
  faHeartbeat as fadHeartbeat,
  faNotesMedical as fadNotesMedical,
  faScrewdriver as fadScrewdriver,
  faCity as fadCity,
  faCar as fadCar,
  faTable as fadTable,
  faFileCertificate as fadFileCertificate,
  faRoad as fadRoad,
  faGasPump as fadGasPump,
  faUmbrellaBeach as fadUmbrellaBeach
} from "@fortawesome/pro-duotone-svg-icons"
import {
  faPlus,
  faBuilding,
  faUserCog,
  faCog,
  faSignOutAlt,
  faTrashAlt,
  faExternalLink,
  faEdit,
  faUserFriends,
  faCheck,
  faTimes,
  faClone,
  faToggleOff,
  faToggleOn,
  faDownload,
  faMobile,
  faEnvelope,
  faShare,
  faExchange,
  faFileAlt,
  faMinusCircle,
  faClock,
  faCalendarAlt,
  faEngineWarning,
  faHistory,
  faCheckDouble,
  faMinus,
  faStar,
  faRocket,
  faUsers,
  faMapMarker,
  faUndoAlt,
  faChevronLeft,
  faMapMarkerAlt,
  faFileSearch,
  faTools,
  faTable,
  faSyncAlt,
  faUserHardHat,
  faHome,
  faBriefcaseMedical,
  faSearch,
  faCar,
  faUser,
  faUserSlash,
  faEuroSign,
  faUsersClass,
  faUserPlus,
  faLockAlt,
  faShieldAlt,
  faSignature,
  faFilePdf,
  faPause,
  faWallet,
  faPhone,
  faAt,
  faStore,
  faListUl,
  faFileImport,
  faArchive,
  faCommentAltLines,
  faCity,
  faUserTag,
  faCarMechanic,
  faUmbrellaBeach
} from "@fortawesome/pro-regular-svg-icons"
import {
  // FIlters
  faSortDown as fasSortDown,
  faFilter as fasFilter,
  faUndoAlt as fasUndoAlt,
  faAngleDoubleLeft as fasAngleDoubleLeft,
  faChevronLeft as fasChevronLeft,
  faMapMarkerAlt as fasMapMarkerAlt,
  faGlobe as fasGlobe,
  faPaperPlane as fasPaperPlane,
  faMobile as fasMobile,
  faGlobeEurope as fasGlobeEurope,
  faCalendarCheck as fasCalendarCheck,
  faCalendarAlt as fasCalendarAlt,
  faHistory as fasHistory,
  faUsers as fasUsers,
  faUserFriends as fasUserFriends,
  faBuilding as fasBuilding,
  faUserCog as fasUserCog,
  faCog as fasCog,
  faStar as fasStar,
  faUserTie as fasUserTie,
  faUser as fasUser,
  faHashtag as fasHashtag,
  faCheckSquare as fasCheckSquare,
  faBolt as fasBolt,
  faFileContract as fasFileContract,
  faClock as fasClock,
  faFileAlt as fasFileAlt,
  faRocket as fasRocket,
  faTools as fasTools,
  faHandsHelping as fasHandsHelping,
  faPaintRoller as fasPaintRoller,
  faFaucetDrip as fasFaucetDrip,
  faFaucet as fasFaucet,
  faScrewdriver as fasScrewdriver,
  faFan as fasFan,
  faRaygun as fasRaygun,
  faUserHardHat as fasUserHardHat,
  faKey as fasKey,
  faBox as fasBox,
  faBoxCheck as fasBoxCheck,
  faDownload as fasDownload,
  faFile as fasFile,
  faFileSearch as fasFileSearch,
  faTable as fasTable,
  faChevronDown as fasChevronDown,
  faHome as fasHome,
  faBriefcaseMedical as fasBriefcaseMedical,
  faCar as fasCar,
  faCheckDouble as fasCheckDouble,
  faChevronUp as fasChevronUp,
  faUsersClass as fasUsersClass,
  faComment as fasComment,
  faSyncAlt as fasSyncAlt,
  faPause as fasPause,
  faWallet as fasWallet,
  faFileExcel as fasFileExcel,
  faListUl as fasListUl,
  faPiggyBank as fasPiggyBank,
  faCommentAltLines as fasCommentAltLines,
  faExclamationTriangle as fasExclamationTriangle,
  faTimes as fasTimes,
  faCity as fasCity,
  faMapMarkedAlt as fasMapMarkedAlt,
  faCarMechanic as fasCarMechanic,
  faUmbrellaBeach as fasUmbrellaBeach,
  faEuroSign as fasEuroSign
} from "@fortawesome/pro-solid-svg-icons"

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"

import "@/plugins/i18n.js"

import Paginate from "vuejs-paginate"

import VeeValidate, { Validator } from "vee-validate"
import sl from "vee-validate/dist/locale/sl"

/**
 * Axios - requests
*/
window.axios = axios.create({ baseURL: process.env.VUE_APP_API })
window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
window.axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded"
window.axios.defaults.withCredentials = true
window.axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.reject(error)
})
// !!! TODO check if we still need this
// window.axios.interceptors.request.use((config) => {
//   if (config.params !== undefined && config.params.page !== undefined) {
//     config.params.pageSize = process.env.VUE_APP_PAGE_SIZE
//     return config
//   }
//   return config
// })

/**
 * Uikit init
 */
Vue.use(UiKit)

Vue.component("ResourceSelect", ResourceSelect)

/**
 * Moment - date and time management
 */
window.moment = moment
Vue.prototype.moment = moment
moment.locale("sl")

/**
 * Notify - notifications
 */
Vue.use(Notify, {
  itemClass: "notification",
  position: "bottom-right"
})
const types = {
  info: { itemClass: "notification--info" },
  error: { itemClass: "notification--error" },
  warning: { itemClass: "notification--warning" },
  success: { itemClass: "notification--success" }
}
Vue.$notify.setTypes(types)

/**
 * Fontawesome
 *
 */
library.add(
  faPlus,
  faCog,
  fasAngleDoubleLeft,
  fasChevronLeft,
  faBuilding,
  faUserCog,
  faSignOutAlt,
  fasMapMarkerAlt,
  fasGlobe,
  fasPaperPlane,
  faEuroSign,
  fasMobile,
  fasCalendarCheck,
  fasCalendarAlt,
  fasHistory,
  fasSortDown,
  fasFilter,
  fasUndoAlt,
  fasUsers,
  fasGlobeEurope,
  faTrashAlt,
  faExternalLink,
  faEdit,
  faUserFriends,
  fasUserFriends,
  fasBuilding,
  fasUserCog,
  faSyncAlt,
  fasCog,
  faCheck,
  faTimes,
  faClone,
  faToggleOff,
  faToggleOn,
  falFileContract,
  faDownload,
  faMobile,
  faEnvelope,
  fasStar,
  fasUserTie,
  fasBolt,
  fasFileContract,
  fasClock,
  faShare,
  faExchange,
  falTimes,
  faFileAlt,
  fasChevronDown,
  fasFileAlt,
  faMinusCircle,
  faClock,
  faCalendarAlt,
  faEngineWarning,
  faHistory,
  faCheckDouble,
  faMinus,
  faStar,
  faRocket,
  fasRocket,
  fasTools,
  faUsers,
  faMapMarker,
  faUndoAlt,
  fasHandsHelping,
  fasPaintRoller,
  fasFaucetDrip,
  fasFaucet,
  fasScrewdriver,
  fasFan,
  fasRaygun,
  fasUserHardHat,
  fasKey,
  faChevronLeft,
  fasBox,
  fasBoxCheck,
  fasDownload,
  fadGhost,
  falFile,
  fadEdit,
  fadFile,
  faMapMarkerAlt,
  fasFile,
  fadFileUpload,
  fadFolderOpen,
  faUser,
  faUserSlash,
  faFileSearch,
  fasFileSearch,
  faTools,
  fasCheckDouble,
  falFolder,
  falArchive,
  falHomeLgAlt,
  falChartBar,
  falPresentation,
  falMobileAlt,
  falDesktop,
  falEnvelopeOpenText,
  falPaperPlane,
  falComments,
  falEuroSign,
  falPencil,
  falLock,
  falLightbulb,
  falPaperclip,
  falSearch,
  falGlobeEurope,
  fadFolder,
  fadArchive,
  fadHomeLgAlt,
  fadTools,
  fadChartBar,
  fadPresentation,
  fadCalendarAlt,
  fadUsers,
  fadMobileAlt,
  fadDesktop,
  fadDownload,
  fadRocket,
  fadEnvelopeOpenText,
  fadPaperPlane,
  fadComments,
  fadEuroSign,
  fadPencil,
  fadLock,
  fadLightbulb,
  fadPaperclip,
  fadSearch,
  fadStar,
  fadGlobeEurope,
  falTools,
  falUsers,
  falCalendarAlt,
  falDownload,
  falRocket,
  falStar,
  falFolderOpen,
  falFileExclamation,
  faTable,
  fasTable,
  fadTable,
  falTable,
  fasHome,
  fasBriefcaseMedical,
  fasCar,
  faCar,
  faUserHardHat,
  faHome,
  faBriefcaseMedical,
  faSearch,
  fasChevronUp,
  faUsersClass,
  fasUsersClass,
  fasComment,
  faUserPlus,
  fasSyncAlt,
  faLockAlt,
  faShieldAlt,
  fadFileDownload,
  fadSignature,
  fadCloudUploadAlt,
  fadFileSignature,
  fadCog,
  faSignature,
  faFilePdf,
  faPause,
  fasPause,
  faWallet,
  fasWallet,
  fasFileExcel,
  fasUser,
  fasHashtag,
  fasCheckSquare,
  falMoneyBillAlt,
  fadMoneyBillAlt,
  faPhone,
  faAt,
  faStore,
  falCogs,
  falUserTie,
  falBuilding,
  falUserGraduate,
  falUserHardHat,
  falBooks,
  falCalendarPlus,
  falShapes,
  falCommentsDollar,
  falUniversity,
  falStore,
  falHandHoldingUsd,
  falIdCard,
  falCars,
  falRingsWedding,
  fadCogs,
  fadUserTie,
  fadBuilding,
  fadUserGraduate,
  fadUserHardHat,
  fadBooks,
  fadCalendarPlus,
  fadShapes,
  fadCommentsDollar,
  fadUniversity,
  fadStore,
  fadHandHoldingUsd,
  fadIdCard,
  fadCars,
  fadRingsWedding,
  faListUl,
  fasListUl,
  fadAbacus,
  fadFileMedical,
  fadFileMedicalAlt,
  fadHeartbeat,
  fadNotesMedical,
  faFileImport,
  fadScrewdriver,
  falScrewdriver,
  falFileSearch,
  faArchive,
  fasPiggyBank,
  fasCommentAltLines,
  fasExclamationTriangle,
  fasTimes,
  falExclamationTriangle,
  falCheckSquare,
  faCommentAltLines,
  fasCity,
  faCity,
  fadCity,
  fadCar,
  faUserTag,
  fasMapMarkedAlt,
  fadFileCertificate,
  falRoad,
  fadRoad,
  faCarMechanic,
  fasCarMechanic,
  falGasPump,
  fadGasPump,
  faUmbrellaBeach,
  fasUmbrellaBeach,
  falUmbrellaBeach,
  fadUmbrellaBeach,
  fasEuroSign
)
Vue.component("Icon", FontAwesomeIcon)

/**
 * Pagination
 */
Vue.component("paginate", Paginate)

/**
 * Validator
 */
Vue.use(VeeValidate)
Validator.localize("sl", sl)
